import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { selectUserData } from '../../reducers/userDataReducer'
import './restaurant-manager.scss'

const RestaurantManager = () => {
  const { t } = useTranslation(['restaurant-manager'])
  const userData = useSelector(selectUserData)
  const userEmail = userData?.user?.email || ''

  return (
    <div className="restaurant-manager">
      <div className="restaurant-manager__container">
        <iframe
          src={`https://elevateoshub.com/embed/dining?email=${encodeURIComponent(userEmail)}`}
          className="restaurant-manager__iframe"
          title={t('restaurant-manager:title')}
          frameBorder="0"
          allowFullScreen
        />
      </div>
    </div>
  )
}

export default RestaurantManager
